export class SocketConfig
{
    constructor(public readonly isSecure:boolean,
                public readonly domain:string,
                public readonly port:number,
                public readonly path:string)
    {
    }

    public get connectionString():string
    {
        const protocol = this.isSecure ? 'wss' : 'ws';
        return `${protocol}://${this.domain}:${this.port}${this.path}`;
    };
}
